import config from "../config/config";
import PointLayer from "./PointLayer";

export default class RentLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Rent', options = { scale: 0.3 });
        this.mapTooltip = null;
    }

    /**
     * 节点加载后的处理
     * @param {*} node 
     * @param {*} info 
     */
    handlerNode(node, info) {
        const locale = config.locale;
        const endText = locale === 'en' ? '' : '租赁情况';
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });
        node.a({
            name: `${info.name} ${endText}`,
            price: info.price,
            percent: (info.rent / 100),
            percentValue: `${info.rent} %`
        });
        node.setDataBindings({
            "a": {
                "n_price": {
                    "id": "$zs3d_lease_n_price"
                },
            }
        });
        if (!this.rentValues) {
            this.rentValues = {};
        }
        this.rentValues[info.id] = {
            startValue: 20,
            endValue: parseInt(Math.random() * 5 + 30)
        };
        this.rentValues[info.id].ds = this.rentValues[info.id].endValue - this.rentValues[info.id].startValue;
    }

    /**
     * 显示图层
     */
    showLayer() {
        super.show();
        this.startLayerAnim();
    }

    /**
     * 隐藏图层
     */
    hideLayer() {
        super.hide();
        this.stopLayerAnim();
    }

    /**
     * 开启租金的数值变化动画
     */
    startLayerAnim() {
        const unit = config.locale === 'en' ? 'yuan/m²' : '元/m²';
        const n_price = config.locale === 'en' ? 'Average: ' : '平均租金：';
        if (!this.rentAnim) {
            const params = {
                delay: 3000,
                duration: 2000,
                easing: t => t,
                finishFunc: () => {
                    this.nodes.forEach(node => {
                        const info = node.a('properties');
                        this.rentValues[info.id] = {
                            startValue: this.rentValues[info.id].endValue,
                            endValue: parseInt(Math.random() * 10 + this.rentValues[info.id].endValue - 5)
                        };
                        if (this.rentValues[info.id].endValue > 35) {
                            this.rentValues[info.id].endValue = 20;
                        }
                        this.rentValues[info.id].ds = this.rentValues[info.id].endValue - this.rentValues[info.id].startValue;
                    });
                    this.rentAnim = ht.Default.startAnim(params);
                },
                action: v => {
                    this.nodes.forEach(node => {
                        const info = node.a('properties');
                        node.a('n_price', n_price);
                        node.a('price', (this.rentValues[info.id].startValue + parseInt(this.rentValues[info.id].ds * v)) + unit)
                    });
                }
            };
            this.rentAnim = ht.Default.startAnim(params);
        }
    }

    /**
     * 关闭租金数值变化的动画
     */
    stopLayerAnim() {
        if (this.rentAnim) {
            this.rentAnim.pause();
            this.rentAnim = null;
        }
    }

}